import flussonic from "./flussonic"

class Dvr {
  constructor() {
    this.drivers = {
      flussonic
    }
  }
  async init(channels) {
    if (!__.device.config("catchup.epg")) return false
    if (__.device.config("catchup.driver")) {
      const res = await this.drivers[__.device.config("catchup.driver")]?.init()
      Object.values(channels).forEach(channel => {
        if (channel.hasDvr) channel.dvr = res[channel.channel_uri.slugify()]
        else channel.dvr = false
      })
    }
    _$.dvr = this
    return true
  }

  async play(payload) {
    if (!payload?.channel) return false

    let res = await this.drivers[__.device.config("catchup.driver")]?.play(payload)
    if (!res) return false

    res = await __.media.play(res).then(res => (__.media.dvr = res ? _$.clone(payload) : false))
    if (!__.media.dvr) return false

    const promise = await _$.progress.create()
    _$.nav.changeScope("player")
    _$.vue.$once(["mediaEnded", "mediaStopped"], () => promise.resolve())

    return promise.done
  }
}

export default new Dvr()
